<div class="container" id="dealer">
  <div class="row">
    <div class="col-md-12">
      <div ng-sticky [offSet]="0" [addClass]="'is-sticky'">
        <button type="button" class="btn btn-primary float-md-right mb-1 ml-1 goUp" (click)="goUp();" aria-label="Back to top" title="Back to top"><i
          class="fas fa-arrow-up" aria-hidden="true"> </i></button>
        <button class="btn btn-primary float-md-right mb-1" (click)="backToSearchResults()"><i class="fas fa-search"> </i> Back to
          Search Results</button>
        <h1 class="dealerName">{{profile.businessName}}</h1>
        <h2 class="dealerId">(Dealer ID: {{profile.id}})</h2>
      </div>
      <br>
      <div active="active">
        <ul class="nav nav-tabs">
          <li *ngIf="profile.bulkDataReport" class="uib-tab nav-item" heading="Dealer Report Search">
            <a [routerLink]="['report-search']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Dealer Report Search</a>
          </li>
          <li *ngIf="!profile.bulkDataReport" class="uib-tab nav-item" heading="Dealer Report Log">
            <a [routerLink]="['report-log']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Dealer Report Log</a>
          </li>
          <li class="uib-tab nav-item" heading="My Profile">
            <a [routerLink]="['profile']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Dealer Profile</a>
          </li>
          <li *appHasAnyAuthority="['MY_QUERY_REPORT', 'QUERY_REPORT', 'INDUSTRY_REPORT']" class="uib-tab nav-item" heading="Query Reports">
            <a [routerLink]="['query-reports']" routerLinkActive="active" class="nav-link" uib-tab-heading-transclude="">Query Reports</a>
          </li>
        </ul>
        <div class="tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div *ngIf="isWindowToLow" style="width:100%; height: 100px;"></div>
    </div>
  </div>
</div>
